import React from 'react';
import './Input.scss';

const Input=(props)=>{
    return(
        <div className="input-field">
             <fieldset>
               <legend>{props.label}</legend>
               <input type={props.type} />
           {props.forgot ?    <p>{props.forgot}</p> : null}
               </fieldset>
        </div>
    )
};
export default Input ;